export default {
    props: {
        messagesCommandsCanceledit: {
            type: String,
            kComposite: 'messages.commands.canceledit'
        }, 
        messagesCommandsCreate: {
            type: String,
            kComposite: 'messages.commands.create'
        }, 
        messagesCommandsCreatechild: {
            type: String,
            kComposite: 'messages.commands.createchild'
        }, 
        messagesCommandsDestroy: {
            type: String,
            kComposite: 'messages.commands.destroy'
        }, 
        messagesCommandsEdit: {
            type: String,
            kComposite: 'messages.commands.edit'
        }, 
        messagesCommandsExcel: {
            type: String,
            kComposite: 'messages.commands.excel'
        }, 
        messagesCommandsPdf: {
            type: String,
            kComposite: 'messages.commands.pdf'
        }, 
        messagesCommandsUpdate: {
            type: String,
            kComposite: 'messages.commands.update'
        }, 
        messagesLoading: {
            type: String,
            kComposite: 'messages.loading'
        }, 
        messagesNoRows: {
            type: String,
            kComposite: 'messages.noRows'
        }, 
        messagesRequestFailed: {
            type: String,
            kComposite: 'messages.requestFailed'
        }, 
        messagesRetry: {
            type: String,
            kComposite: 'messages.retry'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/Messages.js